<template>
  <v-sheet width="520" class="px-16 pt-8 pb-6">
    <p class="mb-6 font-weight-bold text-center text-h5">지점 수정</p>

    <v-form ref="form" lazy-validation>
      <v-sheet class="mt-2 px-4">
        <v-text-field class="rounded-lg mb-4" label="지점 코드" dense outlined v-model="form.branchCode" maxlength="20" required></v-text-field>
        <v-text-field class="rounded-lg mb-4" label="지점명" dense outlined v-model="form.name" maxlength="100" required></v-text-field>
        <v-select
          class="rounded-lg mb-4"
          label="상태"
          dense
          outlined
          :items="statusOptions"
          v-model="form.status"
        ></v-select>
        <v-select
          class="rounded-lg mb-4"
          label="운영 상품"
          dense
          outlined
          multiple
          chips
          :items="productOptions"
          v-model="form.availableProducts"
        ></v-select>
        <v-textarea class="rounded-lg" label="설명" dense outlined rows="3" auto-grow v-model="form.description"></v-textarea>
      </v-sheet>
    </v-form>

    <div class="d-flex justify-center mt-8">
      <v-btn width="100" color="grey lighten-3" depressed class="font-weight-bold rounded-10 mr-3" @click="close">닫기</v-btn>
      <v-btn width="100" dark depressed class="font-weight-bold rounded-10" @click="submit">수정</v-btn>
    </div>
  </v-sheet>
</template>

<script>
export default {
  props: {
    selectedItem: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    statusOptions: [
      { text: "운영 (ACTIVE)", value: "ACTIVE" },
      { text: "비활성 (INACTIVE)", value: "INACTIVE" },
    ],
    productOptions: [
      { text: "메이커샷", value: "makershot" },
      { text: "프리미엄", value: "premium" },
    ],
    form: {
      id: null,
      branchCode: "",
      name: "",
      description: "",
      status: "ACTIVE",
      availableProducts: [],
    },
  }),
  watch: {
    selectedItem: {
      handler(val) {
        if (!val || !val.id) return
        this.form = {
          id: val.id,
          branchCode: val.branchCode || "",
          name: val.name || "",
          description: val.description || "",
          status: val.status || "ACTIVE",
          availableProducts: Array.isArray(val.availableProducts) ? [...val.availableProducts] : [],
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    close() {
      this.$emit("close")
    },
    async submit() {
      if (!this.form.id) {
        alert("수정할 지점 정보가 없습니다.")
        return
      }
      if (!this.form.branchCode) {
        alert("지점 코드를 입력해주세요.")
        return
      }
      if (!this.form.name) {
        alert("지점명을 입력해주세요.")
        return
      }
      if (this.form.availableProducts.length === 0) {
        alert("운영 상품을 최소 1개 이상 선택해주세요.")
        return
      }

      const payload = {
        branchCode: this.form.branchCode,
        name: this.form.name,
        description: this.form.description,
        status: this.form.status,
        availableProducts: this.form.availableProducts,
      }

      try {
        await this.$http.put(`/api/admin/branch/${this.form.id}`, payload)
        alert("지점 정보를 수정했습니다.")
        this.$emit("updated")
      } catch (error) {
        console.error("branch update error", error)
        alert(error?.response?.data?.message || "지점 정보를 수정하는 중 오류가 발생했습니다.")
      }
    },
  },
}
</script>
